import request from '../request'

export function fetchList(params) {
    return request({
        url: '/basic-service/menu/list',
        params
    })
}

export function add(data) {
    return request({
        url: '/basic-service/menu/add',
        method: 'POST',
        data,
    })
}

export function edit(data) {
    return request({
        url: '/basic-service/menu/update',
        method: 'POST',
        data,
    })
}

export function remove(data) {
    return request({
        url: '/basic-service/menu/del',
        method: 'POST',
        data
    })
}